<template>
  <div class="deskblock">
    <h3>年度跟单状况</h3>
    <div id="bar2"></div>
  </div>
</template>
<script>


export default {
  data() {
    return {
      myData: [
        ["报警类型", "开单数", "运输中", "已完成"],
        /* ["2023-01", 12, 14, 16],
        ["2023-02", 10, 8, 5],
        ["2023-03", 12, 7, 20],
        ["2023-04", 12, 14, 16],
        ["2023-05", 10, 8, 5],
        ["2023-06", 12, 7, 20],
        ["2023-07", 12, 14, 16],
        ["2023-08", 10, 8, 5],
        ["2023-09", 12, 7, 20],
        ["2023-10", 12, 14, 16],
        ["2023-11", 10, 8, 5],
        ["2023-12", 12, 7, 20], */
      ],
      searchItem: {
        startTime: "",
        endTime: "",
        roleType: 2,//角色类型(1-销售员，2-跟单员，3-调度员，4-财务员)	
      },
    };
  },
  methods: {
    getData() {
      ///cloud-tms-server-omc/orders/indexPendingCount
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-omc/orders/indexRoleReportOnMonth",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        // item.num = data.ordersMoney;

        for (let i = 0; i < data.length; i++) {
          var arr=[];
          arr[0]=data[i].reportDate;
          arr[1]=data[i].kdCount;
          arr[2]=data[i].orderTransitCount;
          arr[3]=data[i].orderFinishCount;
          this.myData.push(arr);
        }
        this.drawBar();
      });
    },
    drawBar() {
      var that = this;
      this.chart = this.echarts.init(document.getElementById("bar2"));
      const colors = ["#41c733", "#2d8cf0", "#ef5a34", "#3fe0ee"];
      this.option = {
        color: colors,
        backgroundColor: "",
        /* title: {
          text: "车辆状况看板"
        }, */
        grid: {
          x: 30,
          y: 60,
          x2: 30,
          y2: 20, //距离下边的距离
        },
        legend: {
          right: 0, //图例组件离右边的距离
          // orient: "vertical", //布局  纵向布局
          orient: "horizontal", //布局  纵向布局
          width: 350, //图行例组件的宽度,默认自适应
          x: "right", //图例显示在右边
          itemWidth: 10, //图例标记的图形宽度
          itemHeight: 10, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            color: "#dataModal",
            fontSize: 12,
          },
        },
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return (
              val.seriesName + "（" + val.value[val.seriesIndex + 1] + "）"
            );
          },
        },
        dataset: {
          source: this.myData,
        },
        xAxis: { type: "category" },
        yAxis: [
          {
            type: "value",
            name: "订单/单",
            position: "left",
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[0],
              },
            },
            axisLabel: {
              formatter: "{value} ",
            },
          },
          /*{
            type: "value",
            name: "客户/个",
            position: "right",
            right: 100,
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[1],
              },
            },
            axisLabel: {
              formatter: "{value} ",
            },
          },
           {
            type: "value",
            name: "bbb",
            position: "right",
            offset: 50,
            alignTicks: true,
            axisLine: {
              show: true,

              lineStyle: {
                color: colors[2],
              },
            }, 
            axisLabel: {
              formatter: "{value} ",
            },
          },*/
        ],
        series: [
          //系列[
          {
            type: "bar",
            yAxisIndex: 0,
            showBackground: true,
            backgroundStyle: {
              color: colors[0],
              opacity: 0.2,
            },
          },
          {
            type: "bar",
            yAxisIndex: 0,
            showBackground: true,
            backgroundStyle: {
              color: colors[1],
              opacity: 0.2,
            },
          },
          {
            type: "bar",
            yAxisIndex: 0,
            showBackground: true,
            backgroundStyle: {
              color: colors[2],
              opacity: 0.2,
            },
          },
          //{ type: "bar", color: ["#8d8d8d"] },
        ],
      };
      this.chart.setOption(this.option);

      this.chart.resize();
    },
    defaultTime() {
      var date = new Date();
      this.yy = date.getFullYear();
      this.mm = date.getMonth();
      this.dd = date.getDate();

      this.searchItem.startTime = new Date(this.yy, 0, 1).getTime();
      this.searchItem.endTime = new Date(this.yy + 1, 0, 1).getTime() - 1000;
      this.getData();
    },
  },
  //调用
  mounted() {
    this.defaultTime();
  },
};
</script>
<style lang="">
#bar2 {
  width: 100%;
  height: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/gendan/block2.vue